import navRouter from './navRouter'
export default [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/mainPage',
        component: () =>
            import(
                /* webpackChunkName: 'mainPage' */ '../components/pages/mainPage/mainPage.vue'
            ),
        children: [...navRouter],
    },
    {
        path: '/index.html',
        redirect: '/home',
    },
]
